export const templateColumnConfigs = [
  {
    header: 'Business Function*',
    key: 'name',
    width: 40,
    required: true,
    example: 'Business Function Sample',
    type: 'Text',
  },
  {
    header: 'Description',
    key: 'description',
    width: 40,
    example: 'This is just a normal description',
    type: 'Text',
  },
];

export const templateUploadConfig = {
  duplicateKey: 'name',
  itemLabel: 'Business Function',
  sampleItemIdentifier: 'Business Function Sample',
};
